import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  useTheme,
  useMediaQuery,
  Button,
} from '@mui/material';
import { CheckCircle, Cancel, ExpandMore } from '@mui/icons-material';

const MaterialsTable = ({ materials }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const openSLDInNewTab = (url) => {
    localStorage.setItem('materialsData', JSON.stringify(materials));
    window.open(url, '_blank');
  };
  const renderMobileView = () => (
    <Stack spacing={2} alignItems='flex-start' sx={{ width: '100%' }}>
      <Typography variant='h5' fontWeight={600} sx={{ pb: 1 }}>
        Materials
      </Typography>
      {materials.map((material, index) => (
        <Accordion
          elevation={0}
          key={index}
          sx={{
            width: '100%',
            borderRadius: '10px !important',
            border: '1px solid lightgray',
            borderRadius: 2,
            boxShadow: 'none',
            mb: 1,
            '&:before': { display: 'none' },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
            sx={{
              px: 2,
              py: 1,
              minHeight: 0,
              '& .MuiAccordionSummary-content': {
                margin: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              },
            }}
          >
            <Box>
              <Typography variant='subtitle1' fontWeight={600}>
                {material?.product}
              </Typography>
              <Typography variant='body2' color='text.secondary'>
                {material?.brand}
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails sx={{ px: 2, pt: 1, pb: 2 }}>
            <Stack spacing={1.5}>
              <Box>
                <Typography variant='caption' color='text.secondary'>
                  Specification
                </Typography>
                <Typography variant='body2'>{material?.description}</Typography>
              </Box>
              <Stack
                direction='row'
                justifyContent='space-between'
                alignItems='center'
              >
                <Box>
                  <Typography variant='caption' color='text.secondary'>
                    Govt. Approved
                  </Typography>
                  <Stack direction='row' spacing={1} alignItems='center'>
                    {material?.govtApproved === 'YES' ? (
                      <>
                        <CheckCircle color='success' fontSize='small' />
                        <Typography variant='body2'>Yes</Typography>
                      </>
                    ) : (
                      <>
                        <Cancel color='error' fontSize='small' />
                        <Typography variant='body2'>No</Typography>
                      </>
                    )}
                  </Stack>
                </Box>
                <Box>
                  <Typography variant='caption' color='text.secondary'>
                    Quantity
                  </Typography>
                  <Typography variant='body2'>{material?.quantity}</Typography>
                </Box>
                <Box>
                  <Typography variant='caption' color='text.secondary'>
                    Warranty
                  </Typography>
                  <Typography variant='body2'>
                    {material?.warrantyInYears} yrs
                  </Typography>
                </Box>
              </Stack>
            </Stack>
          </AccordionDetails>
        </Accordion>
      ))}
    </Stack>
  );

  const renderDesktopView = () => (
    <Stack spacing={2} alignItems='flex-start'>
      <Stack
        flexDirection='row'
        justifyContent='space-between'
        width='100%'
        pb={2}
      >
        <Typography variant='h5' fontWeight={600}>
          Materials
        </Typography>
        <Button
          alignItems='flex-end'
          sx={{ textTransform: 'none' }}
          variant='outlined'
          onClick={() => openSLDInNewTab('/sld')}
        >
          SLD view
        </Button>
      </Stack>
      <TableContainer
        sx={{ margin: 'auto', border: '1px solid rgb(224, 224, 224)' }}
      >
        <Table size='small'>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell>
                <strong>Item</strong>
              </TableCell>
              <TableCell>
                <strong>Brand</strong>
              </TableCell>
              <TableCell>
                <strong>Specification</strong>
              </TableCell>
              <TableCell>
                <strong>Govt. Approved</strong>
              </TableCell>
              <TableCell>
                <strong>Qty</strong>
              </TableCell>
              <TableCell>
                <strong>Warranty</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {materials.map((material, index) => (
              <TableRow
                key={index}
                sx={{
                  '&:hover': { backgroundColor: '#e3f2fd', cursor: 'pointer' },
                }}
              >
                <TableCell>{material?.product}</TableCell>
                <TableCell>{material?.brand}</TableCell>
                <TableCell>{material?.description}</TableCell>
                <TableCell>
                  {material?.govtApproved === 'YES' ? (
                    <Stack direction='row' spacing={1}>
                      <CheckCircle color='success' fontSize='small' />
                      <Typography variant='body2'>Yes</Typography>
                    </Stack>
                  ) : (
                    <Stack direction='row' spacing={1}>
                      <Cancel color='error' fontSize='small' />
                      <Typography variant='body2'>No</Typography>
                    </Stack>
                  )}
                </TableCell>
                <TableCell>{material?.quantity}</TableCell>
                <TableCell>{material?.warrantyInYears} yrs</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );

  return isMobile ? renderMobileView() : renderDesktopView();
};

export default MaterialsTable;
